export const format = (code) => {
    if(!code) return "#####-###";
    if(code === "BR") return "#####-###";
    if(code === "US") return "#####";
    if(code === "AR") return "A####";
    if(code === "CL") return "#######";
    if(code === "MX") return "#####";
    if(code === "AU") return "#####";

    return "############";
};